import { Drawer as WDrawer, DrawerProps } from '@blueprintjs/core';
import React, { PropsWithChildren } from 'react';

const Drawer = ({ children, ...props }: PropsWithChildren<DrawerProps>) => <WDrawer {...props}>{children}</WDrawer>;

export default Drawer;
